import { useTranslation } from 'react-i18next'

const MumToDisabledChildStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="mumtodisabledchild-start-title"
      {...props}
    >
      <title id="mumtodisabledchild-start-title">{t('antagonists:mumtodisabledchild:components:start')}</title>
      <path
        d="M1418.98 536.71s-23.44 41.49-25.54 46.93c-1.19 3.08-5.17 18.16-7.63 23.89-2.49 5.8-10.51 22.45-12.12 26.35-1.42 3.43-6.75 13.24-6.75 13.24s-3.84-2-2.94-5.26c.47-1.7 3.65-9.03 4.63-11.4 1.49-3.63 3.84-9.87 3.98-10.63s-1.08-1.55-1.72-.21c-.81 1.66-3.64 8.79-5.47 12.96-2.56 5.84-7.7 16.1-7.7 16.1s-2.82-1.76-3.07-4.69c-.16-1.8 3.63-9.76 4.94-12.75 1.31-2.99 4.64-11.65 4.76-12.73.13-1.08-.88-2.01-1.67-.61-.79 1.4-4.3 9.27-5.84 12.21-1.54 2.94-8.96 16.46-8.96 16.46s-3.48-1.84-3.19-5c.17-1.91 4.32-9.38 6.58-13.79 1.66-3.22 4.85-11.4 5.12-12.34.27-.94-.42-1.7-1.38-.33-.96 1.38-4.48 7.71-6.44 10.99-1.96 3.28-8.85 15.34-8.85 15.34s-3.7-1.41-2.71-5.61c.75-3.16 4.4-9 6.21-12.52 2.08-4.05 4.73-10.29 6.1-12.65 1.1-1.92 5.38-11.99 4.61-13.09-1.6-.77-8.91 8.29-13.01 10.27-4.69 3.45-8.78-.01-8.78-.01s6.49-7.24 9.93-10.86c3.44-3.62 11.57-14.89 17.05-18.37 3.89-2.47 12.84-5.71 16.07-11.09 7.62-9.96 20.34-48.28 20.34-48.28l23.47 17.48Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1419.61 536.61c4.95-8.05 14.85-25.71 14.85-25.71l-32.04-12.36s-6.97 24.25-13.22 43.79l20.26 9.46c4.08-6.01 8.09-11.83 10.15-15.18ZM1709.26 623.55c4.42 3.79 8.76.64 8.76.64s-5.94-7.7-9.09-11.57c-3.16-3.87-10.43-15.71-15.63-19.59-3.7-2.76-13.94-12.69-16.76-18.29-9.56-16.57-17.17-57.7-17.17-57.7l-32.87 9.95s14.97 30.58 16.4 33.1c6.12 13.17 14.7 31.88 15.77 35.42.96 3.16 3.81 18.49 5.84 24.4 2.06 5.97 8.82 23.17 10.13 27.18 1.16 3.53 5.75 13.71 5.75 13.71s3.98-1.71 3.32-5.03c-.34-1.73-2.97-9.27-3.77-11.72-1.22-3.73-3.09-10.13-3.18-10.89-.08-.76 1.19-1.46 1.73-.09.68 1.72 2.98 9.03 4.49 13.33 2.12 6.02 6.48 16.63 6.48 16.63s2.94-1.55 3.41-4.45c.29-1.78-2.9-10.01-3.98-13.08-1.08-3.08-3.76-11.97-3.8-13.05-.05-1.08 1.03-1.94 1.71-.48.68 1.46 3.6 9.57 4.91 12.61 1.31 3.05 7.72 17.08 7.72 17.08s3.61-1.57 3.56-4.75c-.03-1.92-3.61-9.68-5.54-14.24-1.41-3.33-3.99-11.73-4.19-12.69s.55-1.67 1.4-.22c.85 1.45 3.89 8.03 5.61 11.44 1.71 3.42 7.69 15.95 7.69 15.95s3.79-1.13 3.11-5.39c-.51-3.21-3.72-9.3-5.27-12.95-1.77-4.19-3.95-10.62-5.14-13.07-.96-1.99-4.47-12.36-3.62-13.39 1.65-.65 8.27 8.93 12.21 11.21ZM1495.96 910.66s2.04 11.86.41 17.58c-1.64 5.72-2.25 14.51-1.23 18.19 1.02 3.68.41 12.67-4.29 16.97-4.7 4.29-14.72 20.44-16.15 24.12-1.43 3.68 3.68 8.18 10.83 10.83 7.16 2.66 16.35 4.29 20.03 2.45 3.68-1.84 4.09-5.11 4.91-8.79.82-3.68 2.45-13.9 6.34-17.79 3.88-3.88 5.11-4.29 5.72-8.59.61-4.29-1.02-6.13-.41-10.63.61-4.5 1.84-7.56 1.84-12.67s-2.45-13.7-2.45-17.58c0-3.88.82-15.54.82-15.54l-26.37 1.43Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1486.15 954.82s11.24-7.16 21.26-4.7 18.81 11.86 18.81 11.86.86 11.68-.61 14.31c-1.47 2.63-10.84 23.1-12.67 26.78-1.84 3.68-5.2 7.63-10.51 7.63-5.32 0-10.14-.75-16.48-3s-12.01-4.77-12.63-6.21c-.61-1.43-2.5-11.72-1.68-13.56.82-1.84-.2-3.68-.2-3.68l-.82-2.04 4.05-8.47 6.37-1.96-.41-5.72 5.52-11.24Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1476.34 984.26s-3.88 1.43-2.25 5.32c1.64 3.88 10.02 9.4 16.15 10.43 6.13 1.02 10.63 2.66 15.33.82 4.7-1.84 4.29-4.09 4.5-6.54s.41-5.32.41-5.32-2.66-3.88-11.65-4.7c-8.99-.82-22.49 0-22.49 0ZM1483.44 970.98s11.8 1.26 21 1.88c9.2.61 11.24 5.72 12.06 6.54.82.82 1.9-4.38 1.84-7.36-.06-2.88.2-8.55-13.9-10.83-10.56-1.71-17.55 4.51-18.89 6.23-1.34 1.72-2.11 3.54-2.11 3.54Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1463.28 569.53s5.35 78.92 12.71 121.06c7.36 42.14 13.38 70.23 11.37 82.93-2.01 12.71-6.69 35.45-5.35 63.54 1.34 28.09 4.68 87.62 4.68 87.62s12.65 4.55 17.91 5.56c7.55 1.45 24.72-5.25 24.72-5.25s4.19-61.18 3.52-87.26c-.67-26.08 9.36-44.14 9.36-64.21 0-20.06 13.17-149.09 14.51-170.49 1.34-21.4 9.91-96.19 9.91-96.19l-103.33 62.69Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1596.9 908.93s-2.04 11.86-.41 17.58c1.64 5.72 2.25 14.51 1.23 18.19-1.02 3.68-.41 12.67 4.29 16.97 4.7 4.29 14.72 20.44 16.15 24.12 1.43 3.68-3.68 8.18-10.83 10.83-7.16 2.66-16.35 4.29-20.03 2.45-3.68-1.84-4.09-5.11-4.91-8.79-.82-3.68-2.45-13.9-6.34-17.79-3.88-3.88-5.11-4.29-5.72-8.59-.61-4.29 1.02-6.13.41-10.63s-1.84-7.56-1.84-12.67 2.45-13.7 2.45-17.58c0-3.88-.82-15.54-.82-15.54l26.37 1.43Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1612.23 964.33-.41 5.72 6.37 1.96 4.05 8.47-.82 2.04s-1.02 1.84-.2 3.68c.82 1.84-1.07 12.13-1.68 13.56s-6.29 3.96-12.63 6.21c-6.34 2.25-11.16 3-16.48 3s-8.67-3.95-10.51-7.63c-1.84-3.68-11.21-24.15-12.67-26.78s-.61-14.31-.61-14.31 8.79-9.4 18.81-11.86c10.02-2.45 21.26 4.7 21.26 4.7l5.52 11.24Z"
        style={{
          fill: '#4f4e47',
        }}
      />
      <path
        d="M1616.53 982.53s3.88 1.43 2.25 5.32c-1.64 3.88-10.02 9.4-16.15 10.43-6.13 1.02-10.63 2.66-15.33.82-4.7-1.84-4.29-4.09-4.5-6.54-.2-2.45-.41-5.32-.41-5.32s4.83-4.47 13.83-5.29c8.99-.82 20.31.58 20.31.58ZM1607.32 965.72c-1.34-1.72-8.33-7.94-18.89-6.23-14.1 2.28-13.84 7.96-13.9 10.83-.06 2.98 1.02 8.18 1.84 7.36.82-.82 2.86-5.93 12.06-6.54 9.2-.61 21-1.88 21-1.88s-.77-1.82-2.11-3.54Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1629.58 567.81s.03 45.37-7.33 87.51c-7.36 42.14-18.76 103.77-16.75 116.48 2.01 12.71 6.69 35.45 5.35 63.54-1.34 28.09-4.68 87.62-4.68 87.62s-12.65 4.55-17.91 5.56c-7.55 1.45-24.72-5.25-24.72-5.25s-4.19-61.18-3.52-87.26c.67-26.08-9.36-44.14-9.36-64.21 0-20.06-5.92-150.04-7.26-171.44-1.34-21.4-10.13-49.27-10.13-49.27l96.31 16.72Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1551.7 182.77c-3.88-.4-11.86-4.2-27 3.65-15.14 7.84-28.74 62.21-29.01 83.56-.26 20.94 9.8 31.87 24.87 39.65 13.99 7.23 55.51 1.34 66.16-4.08 9.91-5.04 17.78-11.87 11.49-30.83-6.64-20.03-5.14-35.21-8.03-49.26-3.02-14.69-10.36-30.35-20.43-37.95-6.98-5.26-12.77-4.2-18.06-4.74Z"
        style={{
          fill: '#814d34',
        }}
      />
      <path
        d="M1524.25 257.29s5.28 22.44 5.19 27.61c-.08 5.17 1.37 16.9-6.91 19.91-13.41 4.88-30.07 10.16-30.07 10.16l-18.92 7.66 3.9 40.66s129.35 12.22 128.62 12.41 8.03-38.31 6.93-37.95-32.47-16.05-37.22-22.07c-4.74-6.02-3.33-17.33-3.7-26.63-.36-9.3.05-22.81.05-22.81l-47.88-8.94Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1549.69 203.2c-10.41-.47-18.79 3.65-22.07 16.24-3.28 12.59-11.34 48.17-11.34 48.17s5.87 17.88 18.64 20.25 28.64.91 35.58-4.74c6.93-5.66 10.95-12.04 10.95-16.78s-2.19-32.11-3.1-39.41c-.91-7.3-7.3-18.43-13.32-20.25-6.02-1.82-11.31-3.28-15.32-3.47Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1577.24 238.96s3.47-6.02 6.57-5.11 0 7.3.73 12.77 2.92 10.4 0 12.04c-2.92 1.64-6.2-.18-6.2-.18s-.73-18.97-1.09-19.52Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1539.73 272.99c.48 1.43 7.77 1.73 12.14 1.18 4.38-.55 12.81-1.63 12.81-3.64 0-2.01-6.79-7.31-9.34-6.76s-2.92 1.64-3.83 1.64-2.37-1.46-4.93-.36-7.77 5.2-6.85 7.94Z"
        style={{
          fill: '#ed7a30',
        }}
      />
      <path
        d="m1542.04 233.33-1.69 4.17s-9.18-3.55-12.15-3.55-7.89 1.51-7.89 1.51l-.47-2.5s5.14-3.69 10.52-2.69 11.67 3.06 11.67 3.06Z"
        style={{
          fill: '#814d34',
        }}
      />
      <path
        d="m1630.74 552.72 39.51-9.61s-19.27-52.19-23.45-67.21c-4.18-15.02-6.71-43.83-7.81-65.48-1.09-21.65-4.72-55.79-12.46-65.68-2.35-3.01-5.7-5.18-9.21-6.76-9.29-5.5-25.22-11.45-25.22-11.45s-22.83 25.44-44.46 22.99c-36.9-4.18-48.76-37.46-48.76-37.46s-12.07 3.63-20.17 5.34c-8.4 1.78-18.38 4.37-26.36 9.69-.53.35-1 .73-1.42 1.13-1.75 1.28-3.43 2.72-4.93 4.37-8.45 9.29-12.62 39.61-15.32 61.12-2.7 21.51-7.36 50.05-12.65 64.72-5.29 14.67-28.38 65.28-28.38 65.28l38.68 12.52s19.47-37.58 23.85-49.73c2.34-6.49 7.99-25.63 13.61-45.1 1.83 9.76 3.41 18.07 4.4 23.23 3.8 19.78-4.3 55.51-7.72 71.87-3.42 16.36-1.48 55.1 1.31 56.22 2.79 1.12 5.13-6.37 37.08-7.89 16.06-.76 48.12 3.17 72.74 9.2 24.37 5.96 53.12 7.93 56.85 4.57 3-2.7 2.13-27.11-.33-47.38.4.95.63 1.49.63 1.49Z"
        style={{
          fill: '#8cabbc',
        }}
      />
      <path
        d="M1555.11 231.97s12.89-4.99 16.05-4.2c2.92.73 5.47 3.1 5.47 3.1l-.73 1.64s-3.1-2.01-6.2-1.28c-3.1.73-12.59 4.93-12.59 4.93l-2.01-4.2Z"
        style={{
          fill: '#814d34',
        }}
      />
      <path
        d="m1533.69 242.67-5.03.8-.33-1.78 6.14-1.29s-.62 2.22-.78 2.27Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1534.41 241.76-5.21-3.61.98-1.55 4.85 3.12-.62 2.04z"
      />
      <path
        d="M1533.61 238.68c-1.47 1.31-1.63 3.22-.29 4.61 1.34 1.39 2.79 1.15 4.19.06 1.65-1.29 1.78-2.77.55-4.34-.87-1.11-2.93-1.68-4.45-.34ZM1567.13 242.23l5.01.91.37-1.77-6.11-1.43s.57 2.24.73 2.29Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        style={{
          fill: '#1a4431',
        }}
        d="m1566.76 241.14 5.09-3.36-.91-1.51-4.73 2.89.55 1.98z"
      />
      <path
        d="M1566.78 238.59c1.44 1.34 1.56 3.25.19 4.62-1.37 1.36-2.97.86-4.33-.26-1.62-1.32-1.57-2.58-.31-4.12.89-1.09 2.97-1.62 4.45-.24Z"
        style={{
          fill: '#1a4431',
        }}
      />
      <path
        d="M1554.58 342.25c-2.54 2.83-8.13 4.49-12.21.95-3.41-2.95-4.35-7.83-1.04-11.84 2.93-3.56 8.76-3.35 12.09-.82 4.23 3.22 3.32 9.31 1.16 11.71Zm-4.51-10.84c-1.08-.82-2.97-.89-3.92.27-1.07 1.3-.77 2.88.34 3.83 1.33 1.14 3.14.61 3.96-.31.7-.78.99-2.75-.38-3.79Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1549.44 329.26c-.69 0-1.39-.02-2.11-.05-23.6-1.2-28.34-23.05-28.38-23.27a.51.51 0 0 1 .4-.61c.31-.05.56.12.61.41.04.21 4.63 21.27 27.42 22.43 20.08 1.03 27.83-13.26 27.91-13.4.14-.26.45-.35.7-.22.25.13.35.45.22.7-.07.15-7.5 14.02-26.77 14.02Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
    </svg>
  )
}

export default MumToDisabledChildStart
